import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  primary = false,
  className = '',
  href,
  to
}: { 
  children: React.ReactNode;
  primary?: boolean;
  className?: string;
  href?: string;
  to?: string;
}) => {
  const buttonClasses = `px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
    primary
      ? 'bg-blue-600 text-white hover:bg-blue-700'
      : 'bg-white text-blue-600 border-2 border-blue-600 hover:bg-blue-50'
  } ${className}`;

  if (href) {
    return (
      <a href={href} className={buttonClasses}>
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <Link to={to} className={buttonClasses}>
        {children}
      </Link>
    );
  }

  return (
    <button className={buttonClasses}>
      {children}
    </button>
  );
};

interface HeaderProps {
  className?: string;
  isHomePage?: boolean;
}

export default function Header({ className = '', isHomePage = false }: HeaderProps) {
  const consultationLink = "https://kronologic.me/1-click/zWxqVT2ASOytpMCtSReRDWxbBRVHiUbHjzqAm5x3Arg";

  if (isHomePage) {
    return null;
  }

  return (
    <header className={`bg-gradient-to-r from-blue-600 to-blue-800 text-white pt-20 pb-48 relative ${className}`}>
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex justify-between items-center mb-12">
          <div className="w-48">
            <a href="https://icpedge.com">
              <img 
                src="/logo.png" 
                alt="ICP EDGE Logo" 
                className="w-full h-auto brightness-0 invert"
              />
            </a>
          </div>
          <div className="flex items-center gap-6">
            <Link 
              to="/find-your-edge" 
              className="text-white hover:text-blue-100 transition-colors font-semibold"
            >
              Find Your Edge
            </Link>
            <Link 
              to="/tools/conversion-unlocker" 
              className="text-white hover:text-blue-100 transition-colors font-semibold"
            >
              Fix Conversion Blockers
            </Link>
            <Button primary href={consultationLink}>Partner With Us</Button>
          </div>
        </div>
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold mb-6">
            Superpowers for your <br />CX Consultancy
          </h1>
          <p className="text-2xl text-blue-100 mb-8">
            Actionable insights your clients will love and your competitors can't match.
          </p>
        </div>
      </div>
    </header>
  );
}